import { FieldLabel } from '../forms';
import { TToolInput } from './types';
import { Input } from '@apia/theme';

export const ToolbarInput = (tool: TToolInput) => {
  const input = <Input className="toolbar__input" {...tool.inputProps} />;

  if (tool.label) return <FieldLabel label={tool.label}>{input}</FieldLabel>;

  return input;
};
